/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./common-hot-video.vue?vue&type=template&id=10654b08&scoped=true&"
import script from "./common-hot-video.vue?vue&type=script&lang=ts&"
export * from "./common-hot-video.vue?vue&type=script&lang=ts&"
import style0 from "./common-hot-video.vue?vue&type=style&index=0&id=10654b08&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10654b08",
  null
  
)

export default component.exports